import React, { useRef } from "react";
import { Modal } from "react-bootstrap";
import LoadingBar from "react-top-loading-bar";
import { imageUrl } from "../../actions/miscAction";
import { navigate } from "gatsby";

const close = imageUrl("close-x-24x24.svg");

const NCNDAModal = (props) => {
  const ref = useRef(null);
  const getMember = () => {
    if (typeof window !== "undefined" && localStorage.getItem("member")) {
      if (localStorage.getItem("mimicmember")) {
        return JSON.parse(localStorage.getItem("mimicmember"));
      } else {
        return JSON.parse(localStorage.getItem("member"));
      }
    }
  };
  const member = getMember();
  return (
    <>
      <LoadingBar height={5} color="#47AD1D" ref={ref} />
      <Modal
        show={props.show}
        onHide={() => {
          props.onHide();
        }}
        className="modal fade salvex-modal modal-md hide-header"
        centered
        contentClassName="nda-modal"
      >
        <div class="modal-body">
          <h4 className="nda-modal-text dashboard-modal-text-fix">NCNDA to Sign!</h4>
          <div
            class="close-btn"
            data-bs-dismiss="modal"
            onClick={() => {
              props.onHide();
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>

          <div class="form-group ">
            <p className="nda-modal"> Please review and agree to the NCNDA by clicking the link below.</p>

            <p
              className="nda-modal"
              style={{ color: "#47ad1d", textDecoration: "underline", cursor: "pointer" }}
              onClick={() => navigate(`/my-account/ncnda-list/`)}
            >
              Click here to review and sign
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default NCNDAModal;
